import { FetchFunction, ObservableFromValue, RequestParameters, Variables } from 'relay-runtime';
import { GraphQLResponse, UploadableMap } from 'relay-runtime/lib/network/RelayNetworkTypes';
import { CacheConfig } from 'relay-runtime/lib/util/RelayRuntimeTypes';

import { MiddlewareArgsType, MiddlewareContextType, MiddlewareResponseType, MiddlewareType } from './relay-types';

export const composeMiddlewares = (middlewares: MiddlewareType[]): FetchFunction => {
    return (
        request: RequestParameters,
        variables: Variables,
        cacheConfig: CacheConfig,
        uploadables?: UploadableMap | null,
    ) => {
        const context: MiddlewareContextType = {};

        let index = -1;

        const dispatch = (i: number, args: MiddlewareArgsType): MiddlewareResponseType => {
            if (i <= index) {
                return Promise.reject(new Error('next() called multiple times'));
            }

            index = i;
            const middleware = middlewares[i];

            if (!middleware) {
                return Promise.reject(new Error('No middleware handled the operation.'));
            }

            return middleware(args, (newArgs: MiddlewareArgsType) => {
                return dispatch(i + 1, newArgs);
            });
        };

        return dispatch(0, {
            context,
            variables,
            cacheConfig,
            uploadables,
            operation: request,
        }) as unknown as ObservableFromValue<GraphQLResponse>;
    };
};
